import { useDebounce } from '@fox/atoms/hooks/use-debounce';
import LinearProgress from '@mui/material/LinearProgress';
import { CSSProperties } from 'react';

/**
 * A linear loading indicator that continues taking up vertical height even when not visible, preventing unwanted
 * layout shift. It also has a delay prop that will debounce the visiblity of the loading bar by a set number of ms -
 * this prevents it from flashing on and off for faster connections.
 */
export const LoadingBar = ({
	loading,
	delay = 0,
	value,
	style,
	color
}: {
	loading: boolean;
	delay?: number;
	value?: number;
	style?: CSSProperties;
	color?: 'info' | 'success' | 'warning' | 'error';
}) => {
	const debouncedLoading = useDebounce(loading, delay);
	const finalLoading = loading ? debouncedLoading : false;
	return finalLoading ? (
		<LinearProgress color={color} variant={typeof value === 'number' ? 'determinate' : undefined} value={value} style={style} />
	) : (
		<div style={{ height: '4px' }}></div>
	);
};
